import { render } from "./SublistElement.vue?vue&type=template&id=54b387c6"
import script from "./SublistElement.vue?vue&type=script&lang=js"
export * from "./SublistElement.vue?vue&type=script&lang=js"

import "./SublistElement.vue?vue&type=style&index=0&id=54b387c6&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/f1hBAg6x/0/olearis-developers/byb/byb_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__